import type { MemberTransactionsTableContext as MemberTransactionsTableContextType } from '@library/types/members/memberTransactions';
import { createContext } from 'react';

export const MemberTransactionsTableContext =
  createContext<MemberTransactionsTableContextType>({
    memberTransactionTypeOptions: [],
    onClickPromotionId: () => {},
    onClickNewWagerId: () => {}
  });
